<template>
    <v-container>
        <v-row class="details__card">
            <v-col cols="3" xl="3" lg="3" md="5" sm="12" class="pa-5">
                <v-row>
                    <v-col cols="12" class="d-flex flex-column">
                        <p
                            class="font-weight-bold d-flex flex-column headline pa-0 ma-0 mb-5"
                        >
                            {{ $get(getBusinessDocumentDetails,"contractor.name",$t('global:empty')) }}
                        </p>
                        <span
                            ><b>{{ `${$t('business-document:title')}` }}:</b>
                            {{ $get(getBusinessDocumentDetails, 'title', '') }}
                        </span>
                        <span
                            ><b>{{ `${$t('business-document:lastModification')}` }}:</b>
                            {{
                                getBusinessDocumentDetails.updatedAt
                                    ? $moment(getBusinessDocumentDetails.updatedAt).format(
                                          `DD/MM/YYYY`
                                      )
                                    : $t('global:empty')
                            }}</span
                        >
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" xl="6" lg="8" md="12" sm="12" class="pa-5">
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="$get(getBusinessDocumentDetails, 'title', '')"
                            :label="$t('business-document:title')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="
                                $get(getBusinessDocumentDetails, 'contractor.name', '')
                            "
                            :label="$t('business-document:contractor')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="findRepresentative(getBusinessDocumentDetails)"
                            :label="$t('business-document:representative')"
                        ></v-text-field>
                    </v-col>
                </v-row>              
                <v-row>
                     <v-col cols="6"
                        ><v-text-field style="width:60%"
                            readonly
                            :value="
                                getBusinessDocumentDetails.createdAt
                                    ? $moment(
                                          getBusinessDocumentDetails.createdAt
                                      ).format('DD-MM-YYYY HH:mm')
                                    : $t('global:empty')
                            "
                            :label="$t('business-document:createdAt')"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6"
                        ><v-text-field
                            style="width:60%; float:right"
                            readonly
                            :value="
                                getBusinessDocumentDetails.expirationDate
                                    ? $moment(
                                          getBusinessDocumentDetails.expirationDate
                                      ).format('DD-MM-YYYY')
                                    : getBusinessDocumentDetails.indefinite?$t('business-document:indefinite'): $t('global:empty')
                            "
                            :label="$t('business-document:expirationDate')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-textarea
                            readonly
                            :value="$get(getBusinessDocumentDetails, 'description', '')"
                            :label="$t('business-document:description')"
                            no-resize
                            rows="1"
                            auto-grow
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    computed: {
        ...mapGetters(['getBusinessDocumentDetails']),
    },
    methods: {
        findRepresentative(item) {
            const id = item.representative
            if (id) {
                const representative = item.contractor?.representatives?.find(
                    e => e._id === id
                )

                return `${this.$get(
                    representative,
                    'name',
                    'Brak'
                )} ${this.$get(representative, 'lastname', '')} ${
                    representative && representative.email ? '•' : ''
                } ${this.$get(representative, `email`, '')} ${
                    representative && representative.phoneNumber ? '•' : ''
                } ${this.$get(representative, 'phoneNumber', '')}`
            }
            return ''
        },
    },
}
</script>
